interface SoundReferenceValuesProps {
    rows: Array<{
        label: string;
        value: string;
    }>;
}
const SoundReferenceValues = ({ rows }: SoundReferenceValuesProps) => {
    return (<div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="flex items-center gap-2 px-5 py-3.5 border-b border-slate-100 bg-slate-50">
        <i className="ri-bar-chart-box-line text-sm text-slate-500"/>
        <h2 className="text-sm font-semibold text-slate-700">참고 값</h2>
      </div>
      <div className="divide-y divide-slate-50">
        {rows.map((row) => (<div key={row.label} className="flex items-start gap-4 px-5 py-3">
            <span className="text-xs font-medium text-slate-400 w-28 flex-shrink-0">{row.label}</span>
            <span className="text-sm text-slate-700 break-all">{row.value}</span>
          </div>))}
      </div>
    </div>);
};
export default SoundReferenceValues;
